<template>
    <span>
        <v-select
            v-model="model"
            v-bind="bindProps"
            v-on="bindEvents"
            ></v-select>
        <input v-for="e in inputVals" type="hidden" v-bind="e" />
    </span>
</template>
<script>
export default {
    name: "SelectInput",
    props: {
        value: {},
        name: {type: String},
        label: {},
        required: {},
        errorMessages: {},
        dark: {},
        outlined:{},
        dense:{},

        appendIcon: {
            type: String,
            default: '$dropdown'
        },
        attach: {
            type: null,
            default: false
        },
        cacheItems: Boolean,
        chips: Boolean,
        clearable: Boolean,
        deletableChips: Boolean,
        disabled: Boolean,
        disableLookup: Boolean,
        eager: Boolean,
        hideSelected: Boolean,
        items: {
            type: Array,
            default: () => [],
            required:true,
        },
        itemColor: {},
        itemDisabled: {},
        itemText: {
            type: [String, Array, Function],
            default: 'text'
        },
        itemValue: {
            type: [String, Array, Function],
            default: 'value'
        },
        menuProps: {},
        multiple: Boolean,
        openOnClear: Boolean,
        returnObject: Boolean,
        smallChips: Boolean,
        prependIcon:{},
        rules: Array,
    },
    data() {
        return {
            val: this.value
        };
    },
    computed: {
        bindProps() {
            let props = Object.assign({}, this.$props);
            delete (props.name);
            delete (props.value);
            return props;
        },
        bindEvents() {
            let listeners = Object.assign({}, this.$listeners);
            delete (listeners.input);
            return listeners;
        },
        model: {
            get() {
                return this.val;
            },
            set(v) {
                this.val = v;
                this.$emit('input', v);
            }
        },
        inputVals() {
            let vals = [];
            if (this.name!==undefined && this.name!==null && this.name !== '') {
                if (this.multiple) {
                    let i  = 0;
                    for (let v of (Array.isArray(this.val)?this.val:[this.val])) {
                        vals.push({
                            name: this.name + '['+(i++)+']',
                            value: (v && v[this.itemValue]) || v,
                        });
                    }
                } else {
                    vals.push({
                        name: this.name,
                        value:(this.val && this.val[this.itemValue]) || this.val,
                    });
                }
            }
            return vals;
        }
    },
    watch: {
        value() {
            this.val = this.value;
        },
    }
}
</script>
